<template>
  <div>
    <router-link
      :to="
        $route.query.branchId
          ? {
              name: 'updateRejectedRecord',
              query: {
                branchId: $route.query.branchId,
                companyId: $route.query.companyId,
                data: JSON.stringify(cleanedData),
              },
            }
          : {
              name: 'updateRejectedRecord',
              query: {
                branchId: $route.query.branchId,
                companyId: $route.query.companyId,
                data: JSON.stringify(cleanedData),
              },
            }
      "
      class="branchDetail_btn other_btn_4"
      >{{ $t("text.actionButtons.update") }}</router-link
    >
  </div>
</template>

<script>
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  computed: {
    cleanedData() {
      const { index, column, ...cleanRecord } = this.data;
      return cleanRecord;
    },
  },
};
</script>
